const t=()=>window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent);export{t as default};
//# sourceMappingURL=isMobile.js.map
